import { Link } from "react-router-dom";
import "./../../pagescss/Bottombar.css";

const Bottombar = () => {



  return (

    <>

     
        <div className="bottombar-container">
          <ul className="bottombar-nav">
            <li className="nav-item">
              <Link to="/" className="nav-link">
                <span className="nav-icon">🏠</span>
                <span className="nav-text">Home</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/about" className="nav-link">
                <span className="nav-icon">ℹ️</span>
                <span className="nav-text">About Us</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/contact" className="nav-link">
                <span className="nav-icon">📧</span>
                <span className="nav-text">Contact Us</span>
              </Link>
            </li>
           
            <li className="nav-item">
              <Link to="/more-options" className="nav-link">
                <span className="nav-icon">☰</span>
                <span className="nav-text">More</span>
              </Link>
            </li>
          </ul>
        </div>
     

    </>

  );
};

export default Bottombar;